export default "assets/images/649fce122b354de2ac725ba5f2661955.png";